export default "__VITE_ASSET__CKc30qrY__"